import api from './api'

const BASE = '/admin/email-templates'

export default {
  /** Liste tous les templates système avec statut de personnalisation par langue */
  async list() {
    const { data } = await api.get(`${BASE}/`)
    return data
  },

  /** Détails d'un template pour une langue (hardcoded + system_db + effective) */
  async get(templateKey, language = 'en') {
    const { data } = await api.get(`${BASE}/${templateKey}`, { params: { language } })
    return data
  },

  /** Sauvegarder (créer ou mettre à jour) un template système */
  async save(templateKey, payload) {
    // payload: { language, subject, body_html, body_text? }
    const { data } = await api.patch(`${BASE}/${templateKey}`, payload)
    return data
  },

  /** Réinitialiser un template système pour une langue (revenir au hardcodé) */
  async reset(templateKey, language) {
    const { data } = await api.delete(`${BASE}/${templateKey}`, { params: { language } })
    return data
  },

  /**
   * Prévisualiser un template (draft ou sauvegardé)
   * @param {string} templateKey
   * @param {object} opts - { language, subject?, body_html?, sample_context? }
   */
  async preview(templateKey, opts = {}) {
    const { data } = await api.post(`${BASE}/${templateKey}/preview`, opts)
    return data
  },

  /**
   * Envoyer un email de test
   * @param {string} templateKey
   * @param {object} opts - { email, language, subject?, body_html? }
   */
  async sendTest(templateKey, opts = {}) {
    const { data } = await api.post(`${BASE}/${templateKey}/send-test`, opts)
    return data
  },

  /**
   * Traduire un texte via LibreTranslate (backend)
   * @param {string} text
   * @param {string} from - langue source (ex: 'en')
   * @param {string} to   - langue cible (ex: 'fr')
   */
  async translate(text, from, to) {
    const { data } = await api.post(`${BASE}/translate`, { text, from, to })
    return data.translated
  },
}
